import React, { useEffect, useRef } from 'react';

import { Container } from '../../../../symphony';

import { LessonHeader } from '../LessonHeader/LessonHeader';
import { LessonFooter } from '../LessonFooter/LessonFooter';
import { UnlockQuizAnswer } from '../Modals/UnlockQuizAnswer/UnlockQuizAnswer';
import { SlDataService } from '../../services/sl-data.service';
import { SlActions } from '../../services/ActionsService/sl-actions';
import { SlLEContext } from '../../global-constants';
import {
	ActionType,
	RequestType,
	IMaterialProps,
} from '../../global-interface';
import { TranslationWarning } from '../TranslationWarning/TranslationWarning';
import { MaterialType } from '../../../../api/private/learn-engine-api/learn-engine-api.interface';
import { useContainerData } from '../../../../shared/public/SlHooks/useContainerData';

export function LessonPagesContainer({
	materialInfo,
	children,
}: IMaterialProps): JSX.Element {
	const {
		lessonPageIndex$: lessonPageIndex,
		openUnlockQuizAnswerModal$: openUnlockQuizAnswerModal,
	} = useContainerData(
		SlLEContext,
		SlDataService,
		['lessonPageIndex$', 'openUnlockQuizAnswerModal$'],
	);

	const lessonRef = useRef(null);

	let isQuestion: boolean = null;

	const { lesson$ } = Container.take(SlLEContext, SlDataService);

	if (lesson$.value) {
		const { children: material } = lesson$.value;
		isQuestion = material[lessonPageIndex - 1]?.children?.some(
			(mat) => mat.materialInfo?.header?.typeId === MaterialType.Question,
		);
	}

	useEffect(() => {
		const { actions$ } = Container.take(SlLEContext, SlActions);
		actions$.next({
			type: ActionType.OnLessonMount,
			requestType: RequestType.Parallel,
		});
	}, []);

	useEffect(() => {
		if (lessonPageIndex && lessonRef.current) {
			lessonRef.current.scrollTo({
				top: 0,
				left: 0,
				behavior: 'smooth',
			});
		}
	}, [lessonPageIndex]);

	return (
		<div sl-test-data="cmpLesson" className="le-lesson-wrapper">
			<LessonHeader materialInfo={materialInfo} />
			{!!lessonPageIndex && (
				<div
					className="le-lesson"
					ref={lessonRef}
				>
					{children[lessonPageIndex - 1] as any}
				</div>
			)}
			<LessonFooter />
			{openUnlockQuizAnswerModal && <UnlockQuizAnswer />}
			<TranslationWarning />
		</div>
	);
}
